import type { KeyboardEvent, Ref } from 'react';
import { asciiScanField } from './asciiScanField';
import { CameraScanField } from './CameraScanField';
import './shelfField.css';

interface ShelfFieldProps {
  /** The input id the "Shelf" label points at, unique per screen. */
  id: string;
  inputRef?: Ref<HTMLInputElement> | undefined;
  value: string;
  /** Typed but not saved yet: the Save button shows. */
  dirty: boolean;
  /** The last save landed and nothing was typed since. */
  saved: boolean;
  /** Disables Save while the screen is busy; the box stays open so a slot scanned meanwhile is not lost. */
  disabled?: boolean | undefined;
  onChange: (value: string) => void;
  onSave: () => void;
}

/**
 * The order's Shelf (FS-051 temporary location) as View Orders and Order Detail show it: a scanner-ready box
 * that saves on Enter or Save. The screen owns the value and the save, so each keeps its own follow-up.
 */
export function ShelfField({ id, inputRef, value, dirty, saved, disabled = false, onChange, onSave }: ShelfFieldProps) {
  return (
    <div className="shelf">
      <label htmlFor={id}>Shelf</label>
      <CameraScanField label="Scan shelf with camera">
        <input
          id={id}
          ref={inputRef}
          value={value}
          {...asciiScanField(onChange, (event: KeyboardEvent<HTMLInputElement>) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              onSave();
            }
          })}
        />
      </CameraScanField>
      {dirty && (
        <button type="button" className="flsave" disabled={disabled} onClick={onSave}>
          Save
        </button>
      )}
      {saved && <span className="saved-note">✓ Saved</span>}
    </div>
  );
}
